import React, {Component} from "react";
import Link from "../../../../lib/components/Link/Link";
import LinksContainer from "../../components/linkelement/LinksContainer";
import LinkCardMain from "../../components/linkelement/LinkCardMain";
import LinkCard from "../../components/linkelement/LinkCard";

class OverviewLinks extends Component {

  render() {
    return <div className="min-h-screen flex items-center justify-center p-10 bg-gradient-to-b from-kiwi1 to-kiwi2 text-green-100">

      <div className="w-full max-w-5xl bg-white/5 backdrop-blur border border-white/10 shadow-2xl rounded-2xl p-8">

        <header className="flex items-center gap-4 mb-6">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center font-bold text-white text-xl shadow-xl bg-gradient-to-br from-kiwiAcc to-green-700">
            RP
          </div>
          <div>
            <h1 className="text-xl font-semibold">Landingpage — Kiwi-Grün kiwkiwkiwi</h1>
            <p className="opacity-90">Wähle eine Kachel — fünf Links übersichtlich dargestellt.</p>
          </div>
        </header>

        <LinksContainer mainTagTitle='Link 1' title='Container 01' width='140px' subtitle='Daten'>
          <LinkCardMain link='/' numOfColumns='1' title='Gruppe 1' />
          <LinkCardMain link='/' numOfColumns='1' title='Gruppe 2' />
          <LinkCardMain link='/' numOfColumns='1' title='Gruppe 3' />
        </LinksContainer>

        <LinksContainer mainTagTitle='Link 2' title='Container 02' width='140px' subtitle='Zugang'>
          <LinkCard link='/' numOfColumns='1' title='Link 1' subtitle='Produkt Übersicht' description='Kurze Beschreibung zum ersten Link.' />
          <LinkCard link='/' numOfColumns='2' title='Link 2' subtitle='Besondere Aktion' description='Kurze Beschreibung zum ersten Link.' />
          <LinkCard link='/' numOfColumns='1' title='Link 4' subtitle='Über uns' description='Kurze Beschreibung zum ersten Link.' />
          <LinkCard link='/' numOfColumns='1' title='Link 5' subtitle='Kontakt' description='Kurze Beschreibung zum ersten Link.' />
          <LinkCard link='/' numOfColumns='1' title='Link 3' subtitle='Blog & Neuigkeiten' description='Kurze Beschreibung zum ersten Link.' />
         </LinksContainer>


        <footer className="text-right mt-6 opacity-80 text-sm">© 2025 <span id="year"></span> peer.kiwi</footer>
      </div>
    </div>
  }
}

export default OverviewLinks;
